import { Table } from 'antd';
import React from 'react';
import { TOOLTIP_Z_INDEX } from '../../../common/constants';
import ColumnTitleWithInfo from '../../../components/ColumnTitleWithInfo';

const renderText = (value) => value || '-';

const renderYesNo = (value) => {
  if (typeof value !== 'boolean') return '-';
  return value ? 'Yes' : 'No';
};

const REQUIRED_CONTENT_COLUMNS = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 200,
    render: renderText,
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 250,
    render: renderText,
  },
  {
    title: 'Qty',
    dataIndex: 'maximumQuantity',
    key: 'maximumQuantity',
    width: 80,
    render: (value) => value ?? '-',
  },
  {
    title: 'Min Required Qty',
    dataIndex: 'minimumQuantity',
    key: 'minimumQuantity',
    width: 140,
    render: (value) => value ?? '-',
  },
];

const CHECKLIST_COLUMNS = [
  {
    title: 'Question',
    dataIndex: 'text',
    key: 'text',
    width: 300,
    render: renderText,
  },
  {
    title: 'Expected Answer',
    dataIndex: 'expected',
    key: 'expected',
    width: 140,
    render: renderYesNo,
  },
  {
    title: (
      <ColumnTitleWithInfo
        title="Mark Damaged"
        info={
          <>
            <div>
              <strong>Yes:</strong> if the answer does not match the expected
              answer, the toy unit is marked as damaged.
            </div>
            <div className="mt-10">
              <strong>No:</strong> the answer is only recorded, the toy unit is
              not marked as damaged.
            </div>
          </>
        }
        zIndex={TOOLTIP_Z_INDEX}
      />
    ),
    dataIndex: 'isBlocking',
    key: 'isBlocking',
    width: 140,
    render: renderYesNo,
  },
];

const ContentTable = ({ title, columns, data: allItems }) => {
  const data = allItems?.filter((item) => !item?.isArchived);
  return (
    <>
      <div className="mb-8 font-weight-bold">{title} :</div>
      {data?.length > 0 ? (
        <Table
          size="small"
          bordered
          columns={columns}
          dataSource={data?.map((item, index) => ({ ...item, key: index }))}
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
      ) : (
        <div>-</div>
      )}
    </>
  );
};

export const ToyRequiredContentsReadOnly = ({ requiredContents }) => (
  <ContentTable
    title="Required Contents"
    columns={REQUIRED_CONTENT_COLUMNS}
    data={requiredContents}
  />
);

export const ToyChecklistReadOnly = ({ checklist }) => (
  <ContentTable
    title="Checklist"
    columns={CHECKLIST_COLUMNS}
    data={checklist}
  />
);
